export var INPUT_SELECT_OPTIONS_YES_OR_NO_AND_ALL = [
    {
        label: 'Все',
        value: 'all',
    },
    {
        label: 'Да',
        value: 'yes',
    },
    {
        label: 'Нет',
        value: 'no',
    },
];
export var INPUT_SELECT_OPTIONS_YES_OR_NO = [
    {
        label: 'Да',
        value: 'yes',
    },
    {
        label: 'Нет',
        value: 'no',
    },
];
export var INPUT_SELECT_OPTION_ALL = {
    label: 'Все',
    value: 'all',
};
//# sourceMappingURL=InputSelectOptions.js.map